
/**------------------------------------------------------
 * Package Names/Id's
 */
export enum EnumOneTimePaymentPackage {
	ApiToken = 'package_api_token'
}

export enum EnumOneTimePaymentPackageType {
	TypeApiToken = 'type_api_token'
}

export enum EnumOneTimePaymentStatus {
	Active	= 'active',
	Deleted	= 'deleted'
}


/**------------------------------------------------------
 * One Time Payment Packages
 */
export const ONE_TIME_PAYMENT_PACKAGES: IOneTimePaymentPackage[] = [
	{
		code			: EnumOneTimePaymentPackage.ApiToken,
		type			: EnumOneTimePaymentPackageType.TypeApiToken,
		packageName		: 'Token Package (250 Tokens)',
		description		: 'Tokens are used to call AI functions in Flying',
		paddlePlanId	: '901870',
		apiTokenCount	: 250
	}
];


/**------------------------------------------------------
 * Interfaces Definition
 */
export interface IOneTimePaymentPackage {
	code			: EnumOneTimePaymentPackage;
	type			: EnumOneTimePaymentPackageType;
	packageName		: string;
	description		: string;
	paddlePlanId	: string;
	apiTokenCount	: number;			// these number of tokens will be allocated with the package
}
